// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"accountVerificationPage_outerContainer__1C8ZK","container":"accountVerificationPage_container__1cMSE","icon":"accountVerificationPage_icon__2N9CN"};